import React from "react";
import { styled } from "../../stitches.config";

import Link from "../Link";
import ArticleLinks from "./ArticleLinks";
import Timer from '../common/Timer'
import CircleButton from '../CircleButton'

import check from '../../assets/img/brid_check.svg'

const BridTile = props => {
  const { article, voteFinished = false } = props;
  const imageHeight = (props.imageHeight ? props.imageHeight : (window.innerWidth > 991 ? 456 : 502));
  var imgUrl = article.picture.img;
  imgUrl = imgUrl.replace("780,0,0,0", "0," + imageHeight + ",0,0");
  const amount = voteFinished ? article.progress?.reqAmount : article.progress?.amount ? article.progress?.amount : 0;
  const progress = Math.round(amount / article.progress?.reqAmount * 10000) / 100;
  return (
    <BoxWrapper
      css={{
        "$$imageHeight": imageHeight + 'px',
        "$$preserveImageRatio": props.preserveImageRatio,
        background: `linear-gradient(to top, #000000, rgba(80, 73, 70, 0.26) 57%, rgba(44, 44, 44, 0)), url("${imgUrl}") no-repeat center center`,
      }}
    >
      <Footer className={article.show_links && article.show_links != 'off' ? 'show-links' : null}>
        <Donate>
          {voteFinished ? 'Zbiórka zakończona' : 'Wesprzyj projekt:'}
        </Donate>
        <Title className="text-on-picture__title">
          <Link to={article.url}>
            {article.title}
          </Link>
        </Title>
        <TitleBottom className="text-on-picture__title" >
          {article.label}
        </TitleBottom>
        <ArticleLinks links={article.links} show={article.show_links} />
      </Footer>
      <ProgressBox>
        <p>Zebrano: <b>{amount || 0} zł z {article.progress?.reqAmount || 0} zł</b></p>
        <ProgressBar css={{ "$$width": `${progress || 100}%` }} />
        <p>{voteFinished ? 'Publikacja materiału za' : 'Pozostały czas do końca zbiórki'}: <b><Timer finishTime={article.time} /></b></p>
      </ProgressBox>
      {voteFinished ?
        <Success>
          <div>
            <img src={check} />
          </div>
          SUKCES!
        </Success> :
        <Link to={article.url} state={{ fromSG: true }}>
          <StyledButton>
            Wesprzyj projekt
          </StyledButton>
        </Link>}
    </BoxWrapper>
  );
};



const ProgressBox = styled("div", {
  position: "absolute",
  zIndex: 2,
  left: "18px",
  right: "18px",
  bottom: "85px",
  "p": {
    fontSize: "18px",
    color: "#fafafa",
    lineHeight: 1.11,
    marginTop: "20px",
    marginBottom: "0",
    "b": {
      letterSpacing: "-0.36px"
    },
    "&:first-of-type": {
      "b": {
        paddingLeft: "10px"
      }
    },
    "&:last-of-type": {
      "b": {
        color: "#ed2024"
      }
    }
  },
  "@media (min-width: 992px)": {
    left: "30px",
    bottom: "30px"
  }
});

const Success = styled("div", {
  position: "absolute",
  display: "flex",
  alignItems: "center",
  height: "48px",
  margin: "0",
  zIndex: 2,
  bottom: "20px",
  left: "18px",
  width: "210px",
  color: "white",
  fontSize: "14px",
  fontWeight: 500,
  "div": {
    display: "flex",
    width: "48px",
    height: "48px",
    border: "2px solid",
    borderColor: "$primary",
    borderRadius: "24px",
    marginRight: "10px"
  },
  "img": {
    fill: "green",
    margin: "auto"
  },
  "@media (min-width: 992px)": {
    bottom: "38px",
    right: "10px",
    left: "unset",
    top: "unset"
  }
});

const ProgressBar = styled("span", {
  position: "relative",
  display: "block",
  width: "100%",
  height: "5px",
  borderRadius: "2.5px",
  backgroundColor: "#272424",
  marginTop: "5px",
  marginBottom: "20px",
  "&:before": {
    content: "",
    position: "absolute",
    top: "0",
    left: "0",
    width: "$$width",
    maxWidth: "100%",
    height: "5px",
    borderRadius: "2.5px",
    backgroundColor: "$primary"
  },
  "@media (min-width: 992px)": {
    width: "550px",
    backgroundColor: "#eeeff3"
  }
});

const Title = styled("span", {
  lineHeight: "30px",
  display: "block",
  position: "relative",
  fontSize: "22px",
  fontWeight: 300,
  fontStretch: "normal",
  fontStyle: "normal",
  letterSpacing: "normal",
  color: "#f4f6fc",
  width: "90%",
  "a, a:hover, a:visited": {
    textDecoration: "none",
    color: "inherit"
  },
  "@media (min-width: 992px)": {
    fontSize: "34px",
    width: "827px"
  }
});

const TitleBottom = styled(Title, {
  fontFamily: "$grotesk",
  fontSize: "14px",
  marginTop: "10px",
  color: "#ffffff",
  "@media (min-width: 992px)": {
    fontSize: "18px",
    color: "#fafafa",
    width: "730px"
  }
});

const BoxWrapper = styled("div", {
  margin: "12px 0",
  position: "relative",
  minHeight: "$$imageHeight",
  display: "flex",
  backgroundSize: "cover",
  "> a": {
    display: "block",
    position: "absolute",
    bottom: "20px",
    left: "18px",
    width: "270px",
    "@media (min-width: 992px)": {
      left: "unset",
      bottom: "38px",
      right: "10px"
    }
  }
});

const StyledButton = styled(CircleButton, {
  margin: "0",
  zIndex: 2,
  width: "210px !important",
  ".circle": {
    background: "transparent !important"
  },
  ".icon": {
    "&:before": {
      borderColor: "#fff !important"
    }
  },
  ".button-text": {
    fontSize: "14px",
    padding: "1.05em 0 !important",
    margin: "0 0 0 3em !important",
    color: "#ffffff !important"
  },
  "&:hover": {
    ".icon": {
      "&.arrow": {
        background: "#fff !important"
      }
    }
  }
});

const Footer = styled("span", {
  display: "block",
  alignSelf: "flex-end",
  zIndex: 2,
  position: "absolute",
  left: "18px",
  bottom: "179px",
  right: "0",
  "@media (min-width: 992px)": {
    left: "30px",
    bottom: "134px",
    "&.show-links": {
      paddingLeft: "250px"
    }
  }
});

const Donate = styled("div", {
  marginBottom: "10px",
  fontSize: "18px",
  fontWeight: 500,
  color: "#f4f6fc",
  zIndex: 3
});

export default BridTile;
